import React from "react";

export const EnvironmentBadge: React.FC = () => {
  const isDev = import.meta.env.DEV;
  const envName = import.meta.env.VITE_ENV || (isDev ? "local" : "production");
  const isStaging = envName === "staging" || window.location.hostname.includes("staging");

  // En producción real no mostramos nada
  if (!isDev && !isStaging) return null;

  const release = String(import.meta.env.VITE_SENTRY_RELEASE || "").slice(0, 7);
  const badgeConfig = {
    label: isDev 
      ? `🛠️ LOCAL (${isStaging ? "STAGING DB" : "DEV DB"})` 
      : `🧪 STAGING ${release && !release.startsWith("develop") ? release : ""}`.trim(),
    bgColor: isDev ? "bg-amber-500 text-black" : "bg-purple-600 text-white",
  };

  return (
    <div 
      className={`fixed bottom-3 right-4 z-[9999] max-w-[calc(100vw-2rem)] truncate px-3 py-1 rounded-full text-xs font-bold shadow-lg pointer-events-none opacity-90 backdrop-blur-sm ${badgeConfig.bgColor}`}
    >
      {badgeConfig.label}
    </div>
  );
};